import { Pipe, PipeTransform } from "@angular/core";

/**
 * Convert Object to array of keys.
 */
@Pipe({
	name: "objectvalues",
})
export class ObjectValuesPipe implements PipeTransform {
	transform(value: any): any[] {
		if (!value) {
			return [];
		}

		const keys = [];
		for (const key in value) {
			keys.push({ key: key, value: value[key], type: this.getType(key, value) });
		}
		return keys;
	}

	getType(key: string, value: any): string {
		const prop = value[key];
		const type = typeof prop;
		if (type === "function" || type == "object") {
			if (prop instanceof Date) {
				return "date";
			}
		}
		return type;
	}
}
